import { useRef, useEffect } from 'react';

interface IProps {
  value: any;
  onChange: Function;
};

const TriStateCheckbox = ({ value, onChange }: IProps) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (inputRef.current instanceof HTMLInputElement) {
      inputRef.current.indeterminate = value === null;
    }
  }, [value]);

  const handleChange = () => {
    if (value === null) {
      onChange(true);
    } else if (value === true) {
      onChange(false);
    } else {
      onChange(null);
    }
  };

  return (
    <input
      type="checkbox"
      ref={inputRef}
      checked={value === true}
      onChange={handleChange}
    />
  );
};

export default TriStateCheckbox;
